import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '@/components/ui/dialog';
import { Users } from 'lucide-react';

export default function WaitlistDialog({
  open, onOpenChange, joiningWaitlist,
  user, selectedLocation, selectedDate, selectedTimeSlot, availability,
  onClose, onJoin,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading uppercase flex items-center gap-2">
            <Users className="w-5 h-5" />
            Slot Fully Booked
          </DialogTitle>
          <DialogDescription className="sr-only">
            This time slot is fully booked. You can join the waitlist to be notified
            if a court becomes available.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
            <p className="font-bold text-yellow-900 mb-2">This time slot is fully booked</p>
            <p className="text-sm text-yellow-800">
              All courts are currently reserved for the selected time. Would you like to join the waitlist?
            </p>
          </div>

          <div className="space-y-3">
            <div className="flex items-center justify-between p-3 bg-muted rounded-xl">
              <span className="text-sm font-medium">Your Queue Position:</span>
              <span className="font-black text-xl text-primary">
                #{(availability?.waitlist_count || 0) + 1}
              </span>
            </div>

            <div className="p-3 bg-blue-50 border border-blue-200 rounded-xl text-sm text-blue-900">
              <p className="font-bold mb-2">📱 How it works:</p>
              <ul className="space-y-1 text-xs">
                <li>• You'll be notified via {user?.email ? 'email' : 'SMS'} if a court becomes available</li>
                <li>• First-come, first-served queue order</li>
                <li>• You must complete payment within 24 hours of notification</li>
                <li>• You can cancel anytime before notification</li>
              </ul>
            </div>

            <div className="pt-2">
              <p className="text-xs text-muted-foreground">
                Selected: {selectedLocation?.name} • {selectedDate} • {selectedTimeSlot}
              </p>
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              variant="outline"
              onClick={onClose}
              className="flex-1"
              disabled={joiningWaitlist}
            >
              Go Back
            </Button>
            <Button
              onClick={onJoin}
              className="flex-1 btn-volt"
              disabled={joiningWaitlist}
            >
              {joiningWaitlist ? 'Joining...' : 'Join Waitlist'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
